import i18n from '../../locales/index'
import restful from '../vuex'
import { Message } from 'view-design'
import axios from 'axios'

const state = {
  ...restful.states('material'),
  targetSyncId: null
}

const getters = {
  ...restful.getters('material')
}

const actions = {
  ...restful.actions('materials'),
  async syncToSubShop ({ commit, state }, id) {
    await axios.post(`materials/${state.targetSyncId}/sync_to_sub_shop`, {
      target_shop_id: id
    })
    Message.success(i18n.t('store_modules_banner_1315'))
  },
  async syncToSubShops ({ commit, state }, ids) {
    await axios.post(`materials/${state.targetSyncId}/sync_to_sub_shops`, {
      target_shop_ids: ids
    })
    Message.success(i18n.t('store_modules_banner_1315'))
  },
}

const mutations = {
  ...restful.mutations('material'),
  targetSyncId (state, targetSyncId) {
    state.targetSyncId = targetSyncId
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
